"use client";

import { BannerCarousel } from "@/components/ui/banner-carousel";
import type { MediaSoundPlacement } from "@/components/ui/media-sound-button";
import type { MediaData } from "@/db/schema/hiive";
import { ASPECT_RATIO_CLASS } from "@/lib/aspect-ratios";
import type { MusicAttachment } from "@/lib/music/attachment";

interface EventBannerCarouselProps {
  bannerMedia: MediaData[];
  eventName: string;
  volumeButtonPosition?: MediaSoundPlacement;
  aspectRatio?: string;
  dotsClassName?: string;
  soundButtonClassName?: string;
  /** Optional banner song (plays over still slides). */
  music?: MusicAttachment | null;
  musicCreditClassName?: string;
}

export function EventBannerCarousel({
  bannerMedia,
  eventName,
  volumeButtonPosition = "bottom-right",
  aspectRatio = ASPECT_RATIO_CLASS.portrait4By5,
  dotsClassName,
  soundButtonClassName,
  music = null,
  musicCreditClassName,
}: EventBannerCarouselProps) {
  const emptyState = (
    <section
      className={`flex w-full items-center justify-center bg-surface text-text-secondary ${aspectRatio}`}
    >
      <div className="text-center">
        <div className="mb-3 text-4xl">🎟️</div>
        <p className="text-sm">Event media coming soon</p>
      </div>
    </section>
  );

  return (
    <BannerCarousel
      media={bannerMedia}
      altName={eventName}
      volumeButtonPosition={volumeButtonPosition}
      aspectRatio={aspectRatio}
      dotsClassName={dotsClassName}
      soundButtonClassName={soundButtonClassName}
      emptyState={emptyState}
      music={music}
      musicCreditClassName={musicCreditClassName}
    />
  );
}
